import { allBlockchainCoin } from '@/assets/static/currency-list'

export default {
  // Temporarily disabling 'All' option
  // activeBlockchain: allBlockchainCoin,
  activeBlockchain: null,
}
